module.exports = __webpack_public_path__ + "static/gallery-6@2x-9889a74287e1fbc0dab311b0c8408496.jpg";